module.exports = __webpack_public_path__ + "cbc68bff82a6a38512eea9c763871df2.pdf";